import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function F({ langKey }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    return (
        <div className={`power-ocean-collection-F ${css['power-ocean-collection-F']}`}>
            <div className="text-box">
                <p className="title">{t('secF_title')}</p>
                <p className="desc">{t('secF_desc')}</p>
            </div>
            <div className="img">
                <NextImage src={require('@publicLocal/power-ocean/collection/pc/de/6.jpg')} alt={t('secF_title')} aria-label={t('secF_title')} />
            </div>
        </div>
    );
}
